import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgManholeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "100%",
	height: "100%",
	viewBox: "0 0 136.426 136.426",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#fff",
		transform: "rotate(-45 68.213 68.213)",
		children: [/* @__PURE__ */ _jsx("path", {
			stroke: "#3b3b3b",
			strokeWidth: "6px",
			d: "M62.407,136.426a2.9,2.9,0,0,1-2.9-2.9v-3.505A62.449,62.449,0,0,1,6.513,77.646H2.9a2.9,2.9,0,0,1-2.9-2.9V63.133a2.9,2.9,0,0,1,2.9-2.9H6.311A62.449,62.449,0,0,1,59.5,6.408V2.9a2.9,2.9,0,0,1,2.9-2.9H74.018a2.9,2.9,0,0,1,2.9,2.9V6.407a62.45,62.45,0,0,1,53.2,53.823h3.408a2.9,2.9,0,0,1,2.9,2.9V74.744a2.9,2.9,0,0,1-2.9,2.9h-3.611A62.45,62.45,0,0,1,76.92,130.019v3.505a2.9,2.9,0,0,1-2.9,2.9Z"
		}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("circle", {
			cx: 68.213,
			cy: 68.213,
			r: 43.7,
			fill: "#fff",
			strokeWidth: "6px",
			stroke: "#3b3b3b"
		}) })]
	})
});
export default SvgManholeIcon;
